import { lazy } from 'react'
import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
const NotasDeProduccionGestion = lazy(() => import('./view/NoDeProGestion'))
const NotasDeProduccionRegistro = lazy(() => import('./view/NoDeProRegistro'))
const NotasDeProduccionActualizar = lazy(() => import('./view/NoDeProActualizar'))
const NotasDeProduccionConsultar = lazy(() => import('./view/NoDeProConsultar'))
const NotasDeProduccionRectificar = lazy(() => import('./view/NoDeProRectificar'))
const NotasDeProduccionFinalizar = lazy(() => import('./view/NoDeProFinalizar'))
const NotasDeProduccionIniciado = lazy(() => import('./view/NoDeProIniciado'))
const NotasDeProduccionCompletado = lazy(() => import('./view/NoDeProCompletado'))
const NotasDeProduccionFinalizado = lazy(() => import('./view/NoDeProdFinalizado'))

export const notasDeProduccionRoutesMap = {
  consultar: {
    path: '/notasDeProduccion/consultar/:id',
    name: 'Consultar Nota de Producción',
  },
  registro: {
    path: '/notasDeProduccion/registro',
    name: 'Registro Notas de Producción',
  },
  actualizar: {
    path: '/notasDeProduccion/actualizar/:id',
    name: 'Actualización Notas de Producción',
  },

  rectificar: {
    path: '/notasDeProduccion/rectificar/:id',
    name: 'Rectificación Notas de Producción',
  },
  finalizar: {
    path: '/notasDeProduccion/finalizar/:id',
    name: 'Finalizar Notas de Producción',
  },
  iniciado: {
    path: '/notasDeProduccion/iniciado',
    name: 'Inicio Nota de Producción',
  },
  completado: {
    path: '/notasDeProduccion/completar',
    name: 'Completar Nota Producción',
  },
  finalizado: {
    path: '/notasDeProduccion/finalizado',
    name: 'Finalizar Notas Producción',
  },
  gestion: {
    path: '/notasDeProduccion/gestion',
    name: 'Consultar Notas Producción', //solo permite hasta 17 caracteres ojito sino desborda
  },
}
const notasDeProduccionRoutes = [
  {
    path: notasDeProduccionRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionRegistro />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionActualizar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.consultar.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionConsultar />
      </OperacionesProvider>
    ),
  },
  {
    path: notasDeProduccionRoutesMap.rectificar.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionRectificar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.finalizar.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionFinalizar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.iniciado.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionIniciado />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.completado.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionCompletado />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: notasDeProduccionRoutesMap.finalizado.path,
    element: (
      <OperacionesProvider>
        <NotasDeProduccionFinalizado />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default notasDeProduccionRoutes
